<template>
	<Spiner />
</template>

<script>
import Spiner from '../components/UI/Spinner.vue';
import quizUrl from '../store/quizUrl';
export default {
	components: {
		Spiner,
	},

	async created() {
		let postValue = {};
		postValue = {
			code: this.$route.query.code,
		};
		try {
			if (localStorage.isAssign) {
				let response = await this.$http.put('resources/profile/asign/google', postValue);
				localStorage.removeItem('isAssign');
				if (response.status === 200) {
					alert('Google was bind to your account');
					this.$router.push({ name: 'account' });
				}
			} else {
				let response = await this.$http.post('auth/user_login/google', postValue);
				localStorage.user_token = response.data.token;
				localStorage.social_img = response.data.img;
				this.$router.push({ name: 'advice' });
			}
		} catch (error) {
			if (error.data.message === 'User not found') {
				alert('User is not registered');
				window.location.replace(quizUrl);
			} else {
				alert('Somethign went wrong');
				this.$router.push({ name: 'login' });
			}
		} finally {
			localStorage.removeItem('isAssign');
		}
	},
};
</script>

<style>
</style>